import React from "react";

import { useVersion } from "./hooks";

export const Version = React.memo(() => {
  const { getVersionProps, values } = useVersion();
  return (
    <div {...getVersionProps()}>
      <span>VERSION&nbsp;</span>
      <span>{values.version}</span>
    </div>
  );
});

Version.displayName = "Version";
